import customAxios from "../index";
import qs from "qs";

export const getServices = (params: any, id?: number) => {
  return customAxios({
    method: "GET",
    url: `/provider-services/${id ? id : ""}`,
    params,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  });
};

export const getProviderServicesList = (params: {
  page?: number;
  limit?: number;
  offset?: number;
  search?: string;
}) => {
  return customAxios({
    method: "GET",
    url: "/provider-services/",
    params,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  });
};

export const getProviderServiceById = (id: number) => {
  return customAxios({
    method: "GET",
    url: `/provider-services/${id}`,
  });
};

export const getServiceDetails = (serviceId: number) => {
  return customAxios({
    method: "GET",
    url: `/services/${serviceId}`,
  });
};

export const toggleServiceStatus = (providerServiceId: number, data: any) => {
  return customAxios({
    method: "PUT",
    url: `/provider-services/${providerServiceId}/status`,
    data: data,
  });
};

export const addService = (data: any) => {
  return customAxios({
    method: "POST",
    url: `/provider-services`,
    data,
  });
};

export const getProviderServiceLocations = (providerId: any) => {
  return customAxios({
    method: "GET",
    url: `/provider/${providerId}/serviceable-locations`,
  });
};

export const updateService = (partnerServiceId: number, data: any) => {
  return customAxios({
    method: "PUT",
    url: `/provider-services/${partnerServiceId}`,
    data,
  });
};

export const deleteService = (partnerServiceId: number) => {
  return customAxios({
    method: "DELETE",
    url: `/provider-services/${partnerServiceId}`,
  });
};
export const getBookingRequests = (params: any) => {
  return customAxios({
    method: "GET",
    url: "/provider-dashboard/booking-appointment",
    params,
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
  });
};

export const resendProviderPaymentLink = (leadId: number | string) => {
  return customAxios({
    method: "POST",
    url: `/provider-dashboard/booking-appointment/leads/${leadId}/resend-payment-link`,
  });
};
export const getProviderProfileManagementDetails = () => {
  return customAxios({
    method: "GET",
    url: `/provider-dashboard/profile-management/provider-details`,
  });
};

export const updateProviderProfileBasicDetails = (data: any) => {
  return customAxios({
    method: "PUT",
    url: "/provider-dashboard/profile-management/basic-details",
    data,
  });
};

export const addServiceableLocation = (data: any) => {
  return customAxios({
    method: "POST",
    url: "/provider-dashboard/profile-management/serviceable-location",
    data,
  });
};

export const deleteServiceableLocation = (serviceableLocationId: number) => {
  return customAxios({
    method: "DELETE",
    url: `/provider-dashboard/profile-management/serviceable-location/${serviceableLocationId}`,
  });
};

export const uploadProviderMedia = (data: any) => {
  return customAxios({
    method: "POST",
    url: "/provider-dashboard/profile-management/upload-gallery-images",
    data,
  });
};

// need to get this API
export const updateBankDetails = (data: any) => {
  return customAxios({
    method: "PUT",
    url: "/provider-dashboard/profile-management/bank-details",
    data,
  });
};

export const addLicenseDetails = (data: any) => {
  return customAxios({
    method: "POST",
    url: "/provider-dashboard/profile-management/add-licence-details",
    data,
  });
};

export const uploadProviderDocument = (data: any) => {
  return customAxios({
    method: "POST",
    url: "/provider-dashboard/profile-management/upload-documents",
    data,
  });
};

export const updateBusinessAddress = (data: any) => {
  return customAxios({
    method: "PUT",
    url: "/provider-dashboard/profile-management/business-address",
    data,
  });
};

export const deleteLicenseDetails = (id: number) => {
  return customAxios({
    method: "DELETE",
    url: `/provider-dashboard/profile-management/delete-licence-details/${id}`,
  });
};

export const updateCategoriesAndServices = (data: any) => {
  return customAxios({
    method: "PUT",
    url: "/provider-dashboard/profile-management/categories-and-services",
    data,
  });
};

export const deleteGalleryImages = (id: number) => {
  return customAxios({
    method: "DELETE",
    url: `/provider-dashboard/profile-management/delete-gallery-images/${id}`,
  });
};
export const getPaymentBillingList = (params: any) => {
  return customAxios({
    method: "GET",
    url: "/provider-dashboard/payment-billing",
    params,
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
  });
};
export const getPaymentBillingDetails = (id: string, timezone: string) => {
  return customAxios({
    method: "GET",
    params: {
      timezone,
    },
    url: `/provider-dashboard/payment-billing/details/${id}`,
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
  });
};
export const downloadInvoice = (id: string, timezone: string) => {
  return customAxios({
    method: "GET",
    params: {
      timezone,
    },
    url: `/provider-dashboard/payment-billing/download-invoice/${id}`,
    responseType: "blob",
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
  });
};
export const shareInvoice = (id: string,
  data: { timezone: string; emails: string[] }) => {
  return customAxios({
    method: "POST",
    data,
    url: `/provider-dashboard/payment-billing/share-invoice/${id}`,
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
  });
};

export const getBookingAppointmentLeads = (params?: any) => {
  return customAxios({
    method: "GET",
    url: `/provider-dashboard/booking-appointment/leads`,
    params,
  });
}

export const getBookingAppointmentLeadById = (leadId: number) => {
  return customAxios({
    method: "GET",
    url: `/provider-dashboard/booking-appointment/leads/${leadId}`,
  });
};
export const updateLeadDataById = (leadId: number, data: any) => {
  return customAxios({
    method: "PUT",
    url: `/provider-dashboard/booking-appointment/leads/${leadId}`,
    data,
  });
};
export const getProviderServices = (partnerId: number) => {
  return customAxios({
    method: "GET",
    url: `/provider-dashboard/${partnerId}/service`,
  });
};

export const sendQuotationToProviderLead = (
  leadId: number,
  data: { partnerServiceIds: number[] }
) => {
  return customAxios({
    method: "POST",
    url: `/provider-dashboard/booking-appointment/leads/${leadId}/send-quotation`,
    data,
  });
};

export const bookPackageFromLead = (
  leadId: number,
  data: {
    services: Array<{
      partnerServiceId: number;
      subServiceIds: number[];
      merchandiseIds: number[];
    }>;
    serviceDateTime: string;
    serviceLocation: string;
  },
  params?: { timezone?: string }
) => {
  return customAxios({
    method: "POST",
    url: `/provider-dashboard/booking-appointment/leads/book-package/${leadId}`,
    data,
    params,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  });
};

export const deleteProviderUploadedDocument = (documentId: number | string) => {
  return customAxios({
    method: "DELETE",
    url: `/provider-dashboard/profile-management/delete-documents/${documentId}`,
  });
}